/** Saved switches used the fixed compressor, now the middle of its range. */
export function normalizeCompressionAmount(value: unknown): number {
  if (typeof value === 'boolean') return value ? 0.5 : 0;
  return typeof value === 'number' && Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 0;
}

/** At 50% this is the original gentle bus compressor; higher amounts lower
 * the threshold and raise the ratio, with bounded makeup ahead of the limiter. */
export function masterCompressionSettings(amount: number) {
  const value = normalizeCompressionAmount(amount);
  return {
    threshold: value <= 0.5 ? -48 * value : -24 - 24 * (value - 0.5),
    knee: 12,
    ratio: value <= 0.5 ? 1 + 4 * value : 3 + 6 * (value - 0.5),
    attack: 0.008,
    release: 0.18,
    makeup: 1 + 1.2 * value,
  };
}
